import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import HoverItemText from "../SiteComponants/SmallComponents/HoverItemText";
import SpecialButton from "../SiteComponants/SpecialButton";

const PopularCard = ({ prodInfo = {}, selectedPrice, setSelectedPrice }) => {
  const [product, setProduct] = useState([]);
  useEffect(() => {
    setProduct(prodInfo);
  }, [prodInfo]);
  return (
    <div className="col-span-12 sm:col-span-6 md:col-span-4 mx-auto">
      <div className="w-full min-h-full bg-front box dark:dark-bg-front ">
        <Link to={"/products/" + product?.id}>
          <div className="h-1/2 overflow-hidden relative group">
            <img
              className="object-cover rounded-t-lg min-h-full mx-auto group-hover:scale-110 duration-200 -z-10"
              src={product?.photo}
              alt="product img"
            />
            <HoverItemText text={"View Product"} />
          </div>
        </Link>
        <div className="px-5 pb-5">
          <h5 className="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">
            {product?.name}
          </h5>
          <div className="text-center">
            {product?.productInfo?.map((item, i) => (
              <button
                key={i}
                onClick={() =>
                  setSelectedPrice({ ...item, id: product?.id, key: i })
                }
                className={`${
                  selectedPrice?.key === i && product?.id === selectedPrice?.id
                    ? "bg-orange-500 border-black"
                    : ""
                } border px-2 py-1 rounded-md mr-3 my-2 text-sm`}
              >
                {item.title}
              </button>
            ))}
          </div>
          <div className="text-center mt-3">
            {selectedPrice && product?.id === selectedPrice?.id && (
              <span className="text-xl font-bold text-gray-900 border bg-orange-300 px-2 py-1 rounded-sm">
                Price : {product?.productInfo[selectedPrice?.key]?.price}{" "}
                &#2547;
              </span>
            )}
          </div>
          <div className="my-3 text-center">
            <Link to={"/products/" + product?.id}>
              <SpecialButton
                text="View Product"
                icon={
                  <i className="fa fa-link text-gray-950" aria-hidden="true"></i>
                }
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopularCard;
